module.exports = __webpack_public_path__ + "static/media/14.0ee95953.jpg";